import React, { useState } from 'react';
import './PopularTours.css';
import photo from "../assets/Rectangle 610-2.png";
import arrow from "../assets/.png"; // Make sure this filename is correct

function PopularTours() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const tours = [
    { id: 1, destination: "PORTUGAL", price: "₹ 5000", image: photo },
    { id: 2, destination: "TOKYO", price: "₹ 5000", image: photo },
    { id: 3, destination: "SHAWSHANK", price: "₹ 5000", image: photo },
    { id: 4, destination: "PORTUGAL", price: "₹ 5000", image: photo },
    { id: 5, destination: "PORTUGAL", price: "₹ 5000", image: photo }
  ];

  const handleNext = () => {
    if (currentIndex < tours.length - 3) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const visibleTours = tours.slice(currentIndex, currentIndex + 3);

  return (
    <div className="popular-tours-container">
      <div className="sectiontitle">
        Popular Tours <span>to Explore</span>
      </div>

      <div className="tours-carousel-container">

        <div className="tours-carousel">
          {visibleTours.map((tour) => (
            <div key={tour.id} className="tour-card">
              <img src={tour.image} alt={tour.destination} className="tour-image" />
              <div className="tour-details">
                <div className="tour-destination">{tour.destination}</div>
                <div className="tour-price">{tour.price}</div>
              </div>
            </div>
          ))}
        </div>

        <button 
          className={`carousel-nav next ${currentIndex >= tours.length - 3 ? 'disabled' : ''}`}
          onClick={handleNext}
          disabled={currentIndex >= tours.length - 3}
          aria-label="Next"
        >
          <img src={arrow} alt="Next" className="arrow-icon" />
        </button>
      </div>
    </div>
  );
}

export default PopularTours;
